import find from 'lodash/find';
import get from 'lodash/get';
import forEach from 'lodash/forEach';
import unescapeRefinement from './unescapeRefinement';

function getRefinement(state, type, attributeName, name, resultsFacets) {
  var res = {
    type: type,
    attributeName: attributeName,
    name: name
  };
  var facet = find(resultsFacets, {
    name: attributeName
  });
  var count;

  if (type === 'hierarchical') {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var split = name.split(facetDeclaration.separator);

    for (var i = 0; facet !== undefined && i < split.length; ++i) {
      facet = find(facet.data, {
        name: split[i]
      });
    }

    count = get(facet, 'count');
  } else {
    count = get(facet, "data[\"".concat(res.name, "\"]"));
  }

  var exhaustive = get(facet, 'exhaustive');

  if (count !== undefined) {
    res.count = count;
  }

  if (exhaustive !== undefined) {
    res.exhaustive = exhaustive;
  }

  return res;
}

function getRefinements(results, state) {
  var clearsQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var res = [];
  forEach(state.facetsRefinements, function (refinements, attributeName) {
    forEach(refinements, function (name) {
      res.push(getRefinement(state, 'facet', attributeName, name, results.facets));
    });
  });
  forEach(state.facetsExcludes, function (refinements, attributeName) {
    forEach(refinements, function (name) {
      res.push({
        type: 'exclude',
        attributeName: attributeName,
        name: name,
        exclude: true
      });
    });
  });
  forEach(state.disjunctiveFacetsRefinements, function (refinements, attributeName) {
    forEach(refinements, function (name) {
      res.push(getRefinement(state, 'disjunctive', attributeName, // we unescapeRefinement any disjunctive refined value since they can be escaped
      unescapeRefinement(name), results.disjunctiveFacets));
    });
  });
  forEach(state.hierarchicalFacetsRefinements, function (refinements, attributeName) {
    forEach(refinements, function (name) {
      res.push(getRefinement(state, 'hierarchical', attributeName, name, results.hierarchicalFacets));
    });
  });
  forEach(state.numericRefinements, function (operators, attributeName) {
    forEach(operators, function (values, operator) {
      forEach(values, function (value) {
        res.push({
          type: 'numeric',
          attributeName: attributeName,
          name: "".concat(value),
          numericValue: value,
          operator: operator
        });
      });
    });
  });
  forEach(state.tagRefinements, function (name) {
    res.push({
      type: 'tag',
      attributeName: '_tags',
      name: name
    });
  });

  if (clearsQuery && state.query && state.query.trim()) {
    res.push({
      attributeName: 'query',
      type: 'query',
      name: state.query,
      query: state.query
    });
  }

  return res;
}

export default getRefinements;